import 'regenerator-runtime/runtime';
import { all } from 'redux-saga/effects';
import { watchAntragEinreichen } from './antragEinreichenSaga';
import { watchAntragsnummerGenerate } from './antragsnummerSaga';
import { watchBankdatenReceived } from './bankdatenvalidierungSaga';
import { watchDiagnoseDetailsListRequest } from './diagnosedetailsListeSaga';
import { watchDiagnoseListRequest } from './diagnoseListeSaga';
import { watchDruckenLinkClicked } from './druckenSaga';
import { watchFileDeleted } from './fileDeletionSaga';
import { watchGesundheitAusschlussListRequest } from './gesundheitAusschlussSaga';
import { watchGesundheitsdatenAfterLoad } from './checkGesundheitsdatenSaga';
import { watchKommunikationsdatenAnlegen } from './kommunikationsdatenAnlegenSaga';
import { watchKontaflex } from './kontaflexSaga';
import { watchLocationChanged } from './produkteReihenfolgeSaga';
import { watchMindestvertragslaufzeit } from './mindestvertragslaufzeitSaga';
import { watchOnboardingVideo } from './onboardingVideoSaga';
import { watchPLZValidierung } from './plzValidierungSaga';
import { watchPersonenSucheTrigger } from './personenSucheSaga';
import { watchProgrammteilnahmeRequest } from './programmTeilnahmeSaga';
import { watchQuoteDB } from './quoteDbSaga';
import { watchResetBeginnAblauf } from './resetBeginnAblaufSaga';
import { watchStaatsbuergerschfatenListRequest } from './staatsbuergerschaftenListeSaga';
import { watchStateSnapshot } from './stateSnapshotSaga';
import { watchUnfallPreiseResetAfterLoad } from './checkUnfallPreiseResetSaga';
import { watchUpdateAbgelaufenerVersicherungsbeginn } from './updateAbgelaufeneVersicherungsbeginnSaga';
import { watchUpdateBeginnAblauf } from './beginnAblaufSaga';
import { watchUpdateSofortschutzActive } from './updateSofortschutzActiveSaga';
import { watchVermittlerFomMapping } from './vermittlerFomSaga';
import { watchVnWechselDataRequested } from './vnWechselDataSaga';
import { watchVnWechselgrundListRequest } from './vnWechselgrundSaga';
import { watchVorversichererListRequest } from './vorversichererListeSaga';
import { watchFilesAfterLoad } from './checkFilesAfterLoadSaga';
import { watchCapStart } from './capStartSaga';
import { watchHealthStatusListRequest } from './healthStatusListSaga';
import { watchTierrassenListRequest } from './tierrassenListeSaga';

export function* rootSaga() {
  yield all([
    watchAntragEinreichen(),
    watchAntragsnummerGenerate(),
    watchBankdatenReceived(),
    watchDiagnoseDetailsListRequest(),
    watchDiagnoseListRequest(),
    watchDruckenLinkClicked(),
    watchCapStart(),
    watchFileDeleted(),
    watchGesundheitAusschlussListRequest(),
    watchGesundheitsdatenAfterLoad(),
    watchKommunikationsdatenAnlegen(),
    watchKontaflex(),
    watchLocationChanged(),
    watchMindestvertragslaufzeit(),
    watchOnboardingVideo(),
    watchPLZValidierung(),
    watchPersonenSucheTrigger(),
    watchProgrammteilnahmeRequest(),
    watchQuoteDB(),
    watchResetBeginnAblauf(),
    watchStaatsbuergerschfatenListRequest(),
    watchStateSnapshot(),
    watchUnfallPreiseResetAfterLoad(),
    watchUpdateAbgelaufenerVersicherungsbeginn(),
    watchUpdateBeginnAblauf(),
    watchUpdateSofortschutzActive(),
    watchVermittlerFomMapping(),
    watchVnWechselDataRequested(),
    watchVnWechselgrundListRequest(),
    watchVorversichererListRequest(),
    watchFilesAfterLoad(),
    watchHealthStatusListRequest(),
    watchTierrassenListRequest(),
  ]);
}
